<template>
  <div :class="['alert', type]" role="alert">
    <button
      type="button"
      class="close"
      data-dismiss="alert"
      aria-label="Close"
      @click="setErrorMessage((errorMessage = ''))"
    >
      <span class="close-btn" aria-hidden="true">&times;</span>
    </button>
    <div>
      <slot name="heading"></slot>
      <slot name="alert-message"></slot>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  props: {
    type: String,
  },
  methods: {
    ...mapMutations(['setErrorMessage']),
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.alert {
  font-family: $font-family-sans-lato;
  border-radius: 4px;
}

.error-alert {
  background-color: #fff6f6;
  border: 1px solid #9e6463;

  h4 {
    color: #973937;
    font-size: 18px;
    font-weight: bold;
  }

  p {
    color: #973937cc;
    font-size: 14px;
  }

  .close-btn {
    color: #973937;
  }
}

.info-alert {
  background-color: #f8ffff;
  border: 1px solid #bedfe6;

  h4 {
    color: #0e566c;
    font-weight: bold;
    font-size: 18px;
  }

  p {
    color: #0e566c;
    font-size: 14px;
  }

  .close-btn {
    color: #0e566c;
  }
}

.warning-alert {
  background-color: #fffaf3;
  border: 1px solid #ccbea0;

  h4 {
    color: #7a4d05;
    font-weight: bold;
    font-size: 18px;
  }

  p {
    color: #7a4d05cc;
    font-size: 14px;
  }

  .close-btn {
    color: #973937;
  }
}

.success-alert {
  background-color: #fcfff5;
  border: 1px solid #a8c599;

  h4 {
    color: #1e561f;
    font-weight: bold;
    font-size: 18px;
  }

  p {
    color: #1e561fcc;
    font-size: 14px;
  }

  .close-btn {
    color: #1e561fcc;
  }
}
</style>